import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

import SearchLayoutComponent from '../../../../../core/layout-components/search';

export const ContainerCardClip = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) => props.isSelectable && 'cursor: pointer;'}
  ${(props) => (props.selected
  ? 'box-shadow: 0px 0px 0px 2px #89E27E inset;'
  : 'box-shadow: 0px 0px 0px 1px #DEDEDF inset;'
)}
  margin-bottom:20px;
  padding: 10px;
  border-radius: 4px;
`;

export const TitleCard = styled(TextLayoutComponent)`
  font-size: 16px;
  font-weight: 500;
  color: #192c47;
`;

export const NoteCard = styled(TextLayoutComponent)`
  font-size: 14px;
  color: #4D5573;
  margin: 10px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const CardClipFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
`;

export const DateCard = styled(NoteCard)`
  margin: 0;
`;

export const CardLink = styled.a`
  font-weight: 500;
`;

export const ContainerList = styled.div`
  overflow-y: scroll;
  flex: 1;
  padding-right: 10px;
`;

export const AddButton = styled(ButtonLayoutComponent)``;

export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
`;

export const ContainerBottom = styled.div``;

export const TextTotal = styled(TextLayoutComponent)``;

export const ClearButton = styled.a``;

export const ContainerInputSearch = styled.div`
  padding: 30px 0;
  background-color: white;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
`;

export const InputSearch = styled(SearchLayoutComponent)`
  &&&&&& {
    width: 100%;
  }
  & > :first-child {
    width: 100%;
  }
`;
